import { Image, Text, View } from 'components';
import Base, { Config } from 'components/megatron/Base';
import React from 'react';
import styles from './index.module.scss';

interface RechargeOption {
  id: number;
  value: number; // 积分
  price: string; // 价格
  gift: number; // 额外赠送
  info: string;  //额外信息（可拨打数量）
}

interface State {
  tibanOptions: any[]
  options: RechargeOption[];
  selectOptionIndex: number;
  selectOptionIndexReadOnly: number;   //默认选中的index,用来设置推荐
  requireScore: number;
  scores?: number;
  showAlert: boolean;
  showDayCardModal?: boolean
}

export default class ScoresRecharge extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '积分充值'
  };

  public state: State = {
    options: [],
    requireScore: 0,
    selectOptionIndex: 0,
    selectOptionIndexReadOnly: 0,
    showAlert: false,
    tibanOptions: [{
      bgImage: "https://assets.gongji58.com/driver/tibanRechargeA3.png",
      desc: '<24小时内电话随便打>',
      info: null
    }, {
      bgImage: "https://assets.gongji58.com/driver/tibanRechargeB3.png",
      desc: '<有效期为30天>',
      info: null
    }],
  };

  public didMount() {
    this.fetchScores();
    this.fetchScoresConfig();
    this.fetchRechargeList();
    this.fetchTibanRechargeList()
  }

  public render() {
    const { options, tibanOptions, selectOptionIndex, selectOptionIndexReadOnly, scores, requireScore, showAlert, showDayCardModal } = this.state;

    return (
      <View className={styles.container}>
        <View className={styles.noticeBox}>
          <View className={styles.cont}>
            <View className={styles.p}>
              <View className={styles.before}>1、</View>
              平台每天1次免积分拨打，并充值赠送积分，如果遇到错误电话请谅解
            </View>
            <View className={styles.p}>
              <View className={styles.before}>2、</View>
              我们每天都做人工审核，去掉一些垃圾信息和重复信息
            </View>
          </View>
        </View> 
        <View className={styles.noticeText}>购买须知：虚拟积分购买后，不支持转让、退换，请斟酌确认！</View>
        <View className={styles.options}>
          {options.map((option, index) => {
            const selected = index === selectOptionIndex;
            return (
              <View
                key={index}
                onClick={this.handleSelectOption.bind(this, index, option)}
                className={this.cx(styles.option, selected && styles.selectedOption)}
              >

                <View className={styles.optionInner}>
                  {index == selectOptionIndexReadOnly && <Image className={styles.abImg} src={this.assets.megatron.rechargeOnsale} />}
                  <View className={styles.optionL}>
                    <Text className={styles.p}>
                      {option.value - option.gift}积分+额外<Text className={styles.red}>赠送{option.gift}积分</Text>
                    </Text>
                  </View>
                  <View className={styles.optionR}>
                    <Text className={styles.price}><Text className={styles.small}>¥</Text>{parseFloat(option.price)}</Text>
                    <View className={styles.btn}>点此充值</View>
                  </View>
                </View>
                
              </View>
            );
          })}
        </View>
        
        <View className={styles.divider}></View>
        <View className={styles.tibanBox}>
          <View className={styles.tibanInner}>
            <View className={styles.h2}>替班司机专用卡</View>
            <View className={styles.p}>不限量拨打带有<Text className={styles.tag}>替班活</Text>的替班活电话</View>
            <View className={styles.tab}>
              {tibanOptions.map((res, ind) => (
                <View className={styles.item} onClick={this.handleBeforeTibanPurchase.bind(null, res.info)}>
                  <Image src={res.bgImage} className={styles.img}/>
                  {(res.info) &&
                    <Text className={styles.price}>
                      {parseFloat(res.info.price)}<Text className={styles.sm}>元</Text>
                    </Text>
                  }
                </View>
              ))}
            </View>
          </View>
        </View>










        <View className={styles.content} style={{display: 'none'}}>
          <Text className={styles.scoresLabel}>当前积分</Text>
          <Text className={styles.scores}>{scores}</Text>
        </View>
        <Text className={styles.description} style={{display: 'none'}}>
          [ 大约可拨打
          <Text className={styles.value}>
            {JSON.parse(this.selectedOption.info || '{}').num}个
          </Text>
          电话 ]
        </Text>


        {showAlert && (
          <View className={styles.alertBox}>
            <View className={styles.alertBg}></View>
            <View className={styles.alertInner}>
              <View className={styles.alertTop}>
                <View className={styles.t1}>
                  <Text className={styles.redTxt}>赠送积分</Text>
                  <Text className={styles.txt}>已到账</Text>
                </View>
              </View>
              <View className={styles.alertBottom}>
                <View className={styles.t2}>
                  <Text className={styles.p}>偶尔会有些招聘电话是错误的</Text>
                  <Text className={styles.p}>特额外再赠送您
                    <Text className={styles.red}>{this.selectedOption.gift}积分</Text>~
                  </Text>
                </View>
                <Text className={styles.txt}>{'<如遇到错误电话请见谅，并及时举报>'}</Text>
                <View className={styles.Btn} onClick={this.hideAlert}>理解，我知道了</View>
              </View>
            </View>
          </View>
        )}

        {showDayCardModal && (
          <View className={styles.alertBox}>
            <View className={styles.alertBg} onClick={() => {
              this.setState({
                showDayCardModal: false
              })
            }}></View>
            <View className={styles.alertInner}>
              <View className={styles.title}>温馨提示</View>
              <View className={styles.ruleModal}>
                <View className={styles.cont}>
                  <Text className={styles.h1}>重要的事情说3遍：</Text>
                  <Text className={styles.h5}>替班包天卡
                    <Text className={styles.red}>只能</Text>
                    打替班活，
                    <Text className={styles.red}>不能打长期</Text>
                  </Text>
                  <Text className={styles.h5}>替班包天卡
                    <Text className={styles.red}>只能</Text>
                    打替班活，
                    <Text className={styles.red}>不能打长期</Text>
                  </Text>
                  <Text className={styles.h5}>替班包天卡
                    <Text className={styles.red}>只能</Text>
                    打替班活，
                    <Text className={styles.red}>不能打长期</Text>
                  </Text>
                </View>
                <View className={styles.btns}>
                  <View className={styles.btn} onClick={() => {
                    this.setState({
                      showDayCardModal: false
                    })
                    this.handleTibanPurchase()
                  }}>好的，我确定要买</View>
                </View>
              </View>
            </View>
          </View>
        )}

      </View>
    );
  }

  private handlePurchase = async ( id?:number ) => {

    const response = await this.apiClient.base.purchaseScores({
      id: id || this.selectedOption.id
    });

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('充值成功');
        this.setState({
          showAlert:true
        })
        this.fetchScores();
      }
    });
  }

  private fetchScoresConfig = async () => {
    // const { body } = await this.apiClient.base.scoresConfig();

    // const requireScore = Number(
    //   body.find(
    //     item => item.category === 'resume' && item.name === 'call_dec_score'
    //   ).value
    // );

    // this.setState({
    //   requireScore
    // });
  }

  private fetchScores = async () => {
    const { body } = await this.apiClient.base.account();

    this.setState({
      scores: body.score
    });
  }

  private fetchRechargeList = async () => {
    const { body: options } = await this.apiClient.base.scoresRechargeList();

    this.setState({
      options,
      selectOptionIndex: options.findIndex(res => res.selected == 1),
      selectOptionIndexReadOnly: options.findIndex(res => res.selected == 1),
    });
  }

  
  private handleSelectOption = (index, option) => {
    this.setState({
      selectOptionIndex: index
    },() => {
      //如果 selectOptionIndex == index ， 这里是进不来的！！！！！！
      // this.handlePurchase()
    });
    this.handlePurchase(option.id)
  }

  private hideAlert = () => {
    this.setState({
      showAlert:false
    });
  }

  private get selectedOption() {
    const { selectOptionIndex, options } = this.state;

    return options[selectOptionIndex] || {};
  }









  

  /** 替班 **/
  private fetchTibanRechargeList = async () => {
    let { tibanOptions } = this.state
    const { body } = await this.apiClient.base.scoresRechargeList({type: 9})

    tibanOptions.map((res, ind) => {
      res.info = body[ind]
    })
    this.setState({
      tibanOptions: [...tibanOptions]
    });
  }

  private tibanPurchaseId:any = null
  private handleBeforeTibanPurchase = async(res) => {
    this.tibanPurchaseId = res.id
    if(res.value == 1) {
      //包天卡
      this.setState({
        showDayCardModal: true
      })
    }else {
      this.handleTibanPurchase()
    }
  }
  private handleTibanPurchase = async ( ) => {
    //要授权手机
    // const rqPhone = await this.user.requireMobile()
    // if(!rqPhone){return;}
    const id = this.tibanPurchaseId
    if(!id) {
      return;
    }

    const response = await this.apiClient.base.purchaseScores({
      id,
      type: 9
    })

    const paymentConfig = {
      appId: response.body.appId,
      nonceStr: response.body.nonceStr,
      package: response.body.package,
      paySign: response.body.paySign,
      signType: response.body.signType,
      timestamp: response.body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        alert('购买成功');
        this.setState({
          showAlert:true
        })
        this.fetchScores();
      }
    });
    
    
  }



}
